import { useQuery } from '@tanstack/react-query'
import { api } from '../api'

interface CapabilitiesResponse {
  capabilities: string[]
}

/**
 * useCapabilities loads the session's role-derived capabilities from
 * GET /api/v1/capabilities so the UI can hide what the caller cannot do.
 *
 * It defaults to an empty set while loading or on error, so nothing privileged
 * flashes before it resolves. This is presentation only — the backend enforces
 * the same capabilities on every route.
 */
export function useCapabilities(): { capabilities: string[]; has: (c: string) => boolean } {
  const { data } = useQuery({
    queryKey: ['capabilities'],
    queryFn: async (): Promise<CapabilitiesResponse> => {
      const res = await api.get('/capabilities')
      return res.data as CapabilitiesResponse
    },
    staleTime: 5 * 60 * 1000,
  })

  const capabilities = data?.capabilities ?? []
  return { capabilities, has: (c: string) => capabilities.includes(c) }
}
